import { TENANTS } from '@Config/Tenants';
import { isMobile } from '@Framework/deviceClassUtils';
import { getDeviceClass } from '@Framework/getDeviceClass';
import { Box, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import theme from '@Ui/theme';
import React from 'react';

import AnimatedDots from '../../atoms/AnimatedDots';
import LogoZava from '../../atoms/LogoZava';
import { Modal } from '../../atoms/Modal/Modal';
import ShopLogo from '../../atoms/ShopLogo';

export interface TransitionModalProps {
  open: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    shopLogo: {
      height: '100%'
    }
  })
);

const TransitionModal = ({ open }: TransitionModalProps): React.ReactElement => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Modal fullscreen={false} closeable={false} open={open}>
        <Grid container alignItems="center" justifyContent="center" direction="column">
          <Box px={isSmall ? 2 : 15} pt={4} pb={isSmall ? 2 : 0}>
            <Grid container spacing={5}>
              <Grid item xs={6}>
                <ShopLogo tenant={TENANTS.COM} mobile={isMobile(getDeviceClass())} alt={'Shop Apotheke Logo'} />
              </Grid>
              <Grid item xs={6}>
                <LogoZava mobile={isMobile(getDeviceClass())} alt={'Zava  Logo'} className={classes.shopLogo} />
              </Grid>
            </Grid>
          </Box>
          <Box pb={3} letterSpacing={0.7}>
            <Typography variant="h2" align="center">
              Wir leiten Sie an unseren
              <br />
              Partner ZAVA weiter
            </Typography>
          </Box>
          <Box pb={6.5} alignItems={'center'} justifyContent="center" overflow="hidden" display={'flex'} width={'100%'}>
            <AnimatedDots />
          </Box>
        </Grid>
      </Modal>
    </>
  );
};

export { TransitionModal };
